/**
 * App.Config - 配置常量模块
 */

import type { RoomShape } from '../types';
import { App } from './App';

/* ─────────────── Module: Config（常量）─────────────── */
App.Config = {
  /** 格子类型枚举 */
  T: {
    WALK: 0,      // 可走管空间
    FORBID: 1,    // 禁行区
    ROOM: 2,      // 设备机房
    END: 3,       // 末端
    RISER: 4,     // 竖井（立管）- 跨层垂直连通
  },

  /** 网格尺寸 */
  GRID: { W: 26, D: 18 },

  /** 楼层间距（世界Y偏移） */
  FLOOR_HEIGHT: 7,

  /** 非活动楼层虚化透明度 */
  GHOST_OPACITY: 0.30,

  /** 竖井立柱颜色 */
  SHAFT_COLOR: 0x2ecc71,

  /** 楼层名称列表 */
  FLOOR_NAMES: [
    '一层', '二层', '三层', '四层', '五层',
    '六层', '七层', '八层', '九层', '十层'
  ],

  /** 主机房形状（2×3） */
  ROOM_SHAPE_MAIN: [[0, -1], [0, 0], [0, 1], [1, -1], [1, 0], [1, 1]] as RoomShape,

  /** 自建机房形状（2×2） */
  ROOM_SHAPE_SMALL: [[0, 0], [1, 0], [0, 1], [1, 1]] as RoomShape,

  /** 末端颜色列表 */
  END_COLORS: [
    0xff6b6b, 0xffd166, 0xa78bfa, 0x06d6a0, 0x4cc9f0,
    0xff70a6, 0xfff07c, 0xb5ead7, 0xc8b6ff, 0xff9770
  ],

  /** 布局名称列表 */
  LAYOUTS: ['环形通道', '环形+十字通道', '回字通道', '空白（自由绘制）'],

  /** 机房颜色 */
  ROOM_COLOR: 0x3da9fc,
};

export default App.Config;
export const Config = App.Config;
